import logger from './logger';
import type { Auth } from './auth';
import type { BreadcrumbLevel, ErrorProvider } from '@dialpad/o11y/metrics';

const breadcrumbLevelMap = new Map<keyof Console, BreadcrumbLevel>([
  ['log', 'info'],
  ['warn', 'warning'],
  ['error', 'error'],
  ['info', 'info'],
  ['debug', 'debug'],
]);

export const connectLoggerToSentry = ({
  errorProvider,
  auth: { authController },
}: {
  errorProvider: ErrorProvider;
  auth: Auth;
}): void => {
  // no need to block application startup
  // just set user label as it ready
  void authController.waitForAuthorized().then(async () => {
    errorProvider.onLabelsSet?.({
      user: authController.getAuthState().userData?.id ?? 'unknown',
    });
  });
  logger.registerMiddleware((logTarget, prop, ...args) => {
    switch (prop) {
      case 'log':
      case 'warn':
      case 'debug':
      case 'info':
        errorProvider.addBreadcrumb({
          category: 'console',
          message: `${logTarget.namespace}: ${args.join(' ')}`,
          data: { arguments: args, logger: 'console' },
          level: breadcrumbLevelMap.get(prop) ?? 'info',
        });
        break;
      case 'error':
        errorProvider.reportError(new Error(args.join(' ')), {
          namespace: logTarget.namespace,
        });
        break;
    }
  });
};
